export const isUnion = (arr1, arr2) => {
  if (!arr1 && !arr2) return [];
  if (!arr1) return [...new Set(arr2)];
  if (!arr2) return [...new Set(arr1)];

  const unionSet = new Set([...arr1, ...arr2]);
  return Array.from(unionSet);
};

// pre-supposes that data has id and name fields, returns empty object not
export const createIdNameMappingFromData = data => {
  if (!data) {
    return {};
  }
  return data.reduce((acc, curr) => {
    if (!curr.id || !curr.name) {
      return acc;
    }
    acc[curr.id] = curr.name;
    return acc;
  }, {});
};

export const fixUrlPath = htmlContent => {
  // handle anchor links and make sure that all links are open in new window
  const processedEmailHtml = htmlContent.replace(
    '</body>',
    `
    <script>
      document.addEventListener('click', function(e) {
      const target = e.target.closest('a');
      if (!target) return;

      const href = target.getAttribute('href');

      // Handle anchor links
      if (href && href.startsWith('#')) {
        e.preventDefault();

        const anchorId = href.substring(1); // Remove the # symbol

        let element = null;

        // Method 1: getElementById (most reliable, no escaping needed)
        element = document.getElementById(anchorId);

        if (!element) {
          // Method 2: Try querySelector with proper escaping
          try {
            // Escape special CSS characters
            const escapedId = anchorId.replace(/([ #;?%&,.+*~':"!^$[\\]()=>|/@])/g, '\\\\$1');
            element = document.querySelector('#' + escapedId);
          } catch (e) {
            console.error('Selector error:', e);
          }
        }

        if (!element) {
          // Method 3: Find by name attribute (old HTML standard), this method worked
          element = document.querySelector('[name="' + anchorId + '"]');
        }

        if (!element) {
          // Method 4: Case-insensitive fallback
          const allElements = document.querySelectorAll('[id]');
          for (let el of allElements) {
            if (el.id.toLowerCase() === anchorId.toLowerCase()) {
              element = el;
              console.log('Found via case-insensitive match:', el.id);
              break;
            }
          }
        }

        if (element) {
          // Scroll with better options
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
        return;
      }

      // Handle external links
      if (href && (href.startsWith('http') || href.startsWith('mailto:'))) {
        e.preventDefault();
        window.open(href, '_blank', 'noopener,noreferrer');
        return;
      }
    });
    </script>
    </body>`
  );

  // replace short links with full url address, eg.: linkedin.com to https:/linkedin.com
  return processedEmailHtml.replace(
    /href\s*=\s*["']([^"']+)["']/gi,
    (match, url) => {
      // If it's already absolute, keep it as-is
      if (
        url.match(/^https?:\/\//i) ||
        url.startsWith('mailto:') ||
        url.startsWith('tel:')
      ) {
        return `href="${url}"`;
      }

      // If it's a relative URL that starts with /, make it absolute
      if (url.startsWith('/')) {
        return `href="https:/${url}"`;
      }

      // If it's a relative URL without protocol and it isn't a personalization (# or {{), add https://
      // Personalizations as URLs will be handled separately
      if (!url.startsWith('#') && !url.startsWith('{{')) {
        return `href="https://${url}"`;
      }

      return match;
    }
  );
};
